import React from 'react';

const Others: React.FC = () => {
  return <div>Others</div>;
};
export default Others;
